module.exports = __webpack_public_path__ + "img/img_sponsor_hover.180b0318.webp";